/*
  Bloc « Cross-sell » de la fiche produit (sections/mh-main-product.liquid).
  - Produit du cross-sell ONCE : la carte est déjà dans la page, rien à charger.
  - Sinon, Shopify ne donne les recommandations que via routes.product_recommendations_url : on charge la section
  mh-cross-sell (une carte par produit recommandé), on garde le premier produit qui n'est ni dans
  data-exclude (produits associés de « Vous aimerez aussi ») ni dans un carrousel de la page, on y met
  le surtitre du bloc, puis on l'affiche. Sans produit à proposer, le bloc reste masqué.
  Si « Vous aimerez aussi » utilise les recommandations Shopify (produit sans produits associés), le
  produit proposé en est retiré par assets/mh-recommendations.js (window.mhCrossSellProductId et
  événement « mh:cross-sell »).
*/
if (!customElements.get('mh-cross-sell')) {
  customElements.define('mh-cross-sell', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.mh-card-cross-sell')) return;
      const url = this.dataset.url;
      if (!url || this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      const exclude = new Set((this.dataset.exclude || '').split(',').filter(Boolean));
      document.querySelectorAll('.mh-product-slider .mh-card-product[data-product-id]').forEach((card) => {
        exclude.add(card.dataset.productId);
      });

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const card = [...doc.querySelectorAll('.mh-card-cross-sell')].find((item) => !exclude.has(item.dataset.productId));
          if (!card) return;
          const eyebrow = card.querySelector('.mh-card-cross-sell__eyebrow');
          if (eyebrow) {
            if (this.dataset.eyebrow) eyebrow.textContent = this.dataset.eyebrow;
            else eyebrow.remove();
          }
          this.replaceChildren(card);
          this.hidden = false;
          window.mhCrossSellProductId = card.dataset.productId;
          document.dispatchEvent(new CustomEvent('mh:cross-sell', { detail: { productId: card.dataset.productId } }));
        })
        .catch(() => {});
    }
  });
}
